import { jsx as t, jsxs as E, Fragment as h } from "react/jsx-runtime";
import { DiaryEntryType as i } from "../../../helpers/daymaptypes.js";
import "../../../queries/message/index.js";
import "../../../queries/contact/index.js";
import { calendars as k } from "../../../queries/calendars/index.js";
import { V as f, D as b, b as N, N as w } from "../../../pointsGraph-DTJju-rA.js";
import "../../../queries/student/index.js";
import "../../../queries/settings/index.js";
import "../../../queries/points/index.js";
import "../../../queries/assessment/index.js";
import "../../../queries/assessment/annotations/index.js";
import "../../../queries/assessment/rubrics/index.js";
import "../../../queries/assessment/qcesubjects/index.js";
import "../../../queries/assessment/extensionrequest/index.js";
import "../../../queries/files/index.js";
import "../../../queries/attendance/index.js";
import "../../../queries/forms/index.js";
import "../../../queries/notifications/index.js";
import "../../../queries/interviews/index.js";
import "../../../queries/notes/index.js";
import "../../../queries/annoucements/index.js";
import "../../../queries/payments/index.js";
import "../../../queries/assessment/analysis/index.js";
import "../../../queries/group/index.js";
import "../../../queries/projects/index.js";
import "../../../queries/courses/index.js";
import "../../../queries/password/index.js";
import { DaymapSkeleton as x } from "../../skeletons/index.js";
import { DiaryItem as C } from "./events.js";
import { Tooltip as F, Chip as S } from "@mui/material";
import { M as u } from "../../../Label-DyVniv3J.js";
const nr = ({ date: d, studentId: m, onClick: D, hideStudentChip: I, clickableTypes: a }) => {
  const { isPending: v, data: e } = new k.DiaryItems({
    from: d,
    studentId: m || 0
  }).ToQuery();
  return v ? /* @__PURE__ */ t(x, { type: "listitems" }) : /* @__PURE__ */ E(h, { children: [
    e == null ? void 0 : e.slice().sort((r, p) => (r.Type == i.Task ? r.Finish : r.Start).getTime() - (p.Type == i.Task ? p.Finish : p.Start).getTime()).map((r) => {
      const p = !a || a.includes(r.Type);
      let c = [], T = r.Title, y = r.Text;
      switch (r.Type) {
        case i.Note:
          T = "", y = r.Title, r.Colour == "" && (r.Colour = f({ eventType: r.Type }, {}).color);
          break;
      }
      return r.Type == i.Note && r.EventId > 0 ? null : (r.Type == i.Lesson && e.some((n) => n.Type == i.Note && n.EventId == r.ID) && e.filter((o) => o.Type == i.Note && o.EventId == r.ID).forEach((o) => {
        let l = o.Colour || f({ eventType: o.Type }, {}).color;
        l.startsWith("#") == !1 && (l = `#${l}`);
        let s = o.Title.replace("<br>", "");
        s = s.length > 20 ? s.substring(0, 17) + "..." : s, c.push(/* @__PURE__ */ t(
          F,
          {
            title: /* @__PURE__ */ t(u, { skipHtml: !0, allowedElements: ["p"], children: o.Title.replace("<br>", "") }),
            children: /* @__PURE__ */ t(
              S,
              {
                sx: { bgcolor: l, color: "white" },
                size: "small",
                label: /* @__PURE__ */ t(
                  u,
                  {
                    skipHtml: !0,
                    components: {
                      p: ({ children: g }) => /* @__PURE__ */ t("p", { style: { margin: 0 }, children: g })
                    },
                    children: s
                  }
                ),
                icon: /* @__PURE__ */ t(b, { sx: { color: "white !important" }, iconType: N.Note })
              }
            )
          },
          o.ID
        ));
      }), /* @__PURE__ */ t(
        C,
        {
          hideStudentChip: I,
          onClick: p ? D : void 0,
          ...r,
          Title: T,
          Text: y,
          chips: c
        },
        `${r.Type} ${r.ID}`
      ));
    }),
    !e || e.length == 0 ? /* @__PURE__ */ t(w, { children: "There are no events for this date" }) : /* @__PURE__ */ t(h, {})
  ] });
};
export {
  nr as EventForDays
};
//# sourceMappingURL=eventForDays.js.map
